import React from "react";

import startCase from "lodash/startCase";
import styled from "styled-components";

// Not yet populated by map-rs — hide until there's real data to show.
// Remove from this list once the tile starts sending real values.
const UNPOPULATED_FIELDS = new Set(["serviceCompany", "rigNumber", "id", "source"]);

/**
 * Generic label/value rendering of a Rig/Frac Crew map feature's tile
 * properties, so the tooltip (RigFracDetail) auto-adapts if map-rs adds
 * more properties to the tile later.
 */
export function RigFracFields({
  properties
}: {
  properties: Readonly<Record<string, unknown>>;
}) {
  return (
    <Grid>
      {Object.entries(properties)
        .filter(([key, value]) => value != null && !UNPOPULATED_FIELDS.has(key))
        .map(([key, value]) => (
          <React.Fragment key={key}>
            <Title>{startCase(key)}:</Title>
            <ItemInfo>{String(value)}</ItemInfo>
          </React.Fragment>
        ))}
    </Grid>
  );
}

const Grid = styled.div`
  display: grid;
  grid-template-columns: max-content 1fr;
  align-items: flex-end;
  gap: 2px 8px;
`;

const Title = styled.h5`
  font-size: 1.2rem;
  color: white;
  min-width: 100px;
  text-align: right;
  filter: drop-shadow(0 0 16px var(--color-surface-05));
  min-height: 20px;
  line-height: 1.2;
  max-width: 200px;
  align-content: center;
`;

const ItemInfo = styled.span`
  display: block;
  margin-left: 5px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #cdfffa;
  max-width: 220px;
  font-size: 1.2rem;
  font-weight: bold;
  filter: drop-shadow(0 0 16px var(--color-surface-05));
  align-content: center;
`;
